module.exports = __webpack_public_path__ + "static/img/dianxin.969e15c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newimg/dianxin.png
// module id = JJYx
// module chunks = 0